import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Meta, Title } from '@angular/platform-browser';
import {
  termsPageDescription,
  termsPageTitle,
  defaultMetaImage,
} from '../../../core/pure-functions/upload/ng-universal-tags';
import { getExtension } from '../../../core/pure-functions/upload/image-upload-helper';

@Component({
  selector: 'app-tos-dialog',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
})
export class TermsOfServiceComponent {
  constructor(
    public dialogRef: MatDialogRef<TermsOfServiceComponent>,
    private title: Title,
    private meta: Meta,
  ) {
    this.setTags();
  }

  private setTags(): void {
    this.title.setTitle(termsPageTitle);
    this.meta.addTag({
      property: 'description',
      content: termsPageDescription,
    });

    // twitter
    this.meta.addTag({
      property: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.addTag({
      property: 'twitter:title',
      content: termsPageTitle,
    });
    this.meta.addTag({
      property: 'twitter:description',
      content: termsPageDescription,
    });
    this.meta.addTag({
      property: 'twitter:image',
      content: defaultMetaImage,
    });

    // object graph
    this.meta.addTag({
      property: 'og:site_name',
      content: 'Anchor',
    });
    this.meta.addTag({
      property: 'og:locale',
      content: 'en_US',
    });
    this.meta.addTag({
      property: 'og:title',
      content: termsPageTitle,
    });
    this.meta.addTag({
      property: 'og:type',
      content: 'anchor:project',
    });
    this.meta.addTag({
      property: 'og:description',
      content: termsPageDescription,
    });
    this.meta.addTag({
      property: 'og:url',
      content: window.location.href,
    });
    this.meta.addTag({
      property: 'og:image',
      content: defaultMetaImage,
    });
    this.meta.addTag({
      property: 'og:image:type',
      content: 'image/' + getExtension(defaultMetaImage),
    });
  }
}
